import { USER_TOKEN } from '../constant';
import { isEmpty } from '../is';
import { hashModeURL, parseSearch, URLLike, searchBatchAppend } from '../url';
// import { sessionStorage } from './web';
import { webStorageAdapter, createProxyStorage } from './proxy_storage';

export interface UserToken {
  // 区服 id
  partition: string;
  // 账号类型, 1 wx, 2 qq， 在体验服上，可能是 以 1 开头的数字，或者是 以 2 开头的数字
  areaid: string;
  // 角色 id
  roleid: string;
  // 平台类型
  platid: string;
  algorithm: string;
  // 版本
  version: string;
  // 时间戳
  timestamp: string;
  appid: string;
  openid: string;
  sig: string;
  encode: string;
  msdkEncodeParam: string;
}

export const loginWeb = async () => {
  const storage = createProxyStorage<{ [USER_TOKEN]: UserToken }>({
    adapter: webStorageAdapter,
    storage: sessionStorage,
  });
  const url = hashModeURL();
  const token: UserToken = (parseSearch(url) as unknown) as UserToken;

  if (isEmpty(token)) {
    // return sessionStorage.getItemSync<UserToken>(USER_TOKEN);
    return storage.getItem(USER_TOKEN);
  }
  // sessionStorage.setItem(USER_TOKEN, token);
  storage.setItem(USER_TOKEN, token);
  return token;
};

export const loginMini = async () => {
  // TODO: login mini
};

export const login = (type: 'web' | 'mini' = 'web') => (type === 'web' ? loginWeb() : loginMini());

// only for web
export const newURLWithToken = (url?: URLLike) => searchBatchAppend(loginWeb(), url);
